import { Card, CardBody } from 'reactstrap';

export const EmptyTeamState = () => {
  return (
    <Card>
      <CardBody className="py-5 text-center">
        <div className="mb-3">
          <i className="ri-computer-line fs-1"></i>
        </div>
        <h5 className="mb-2">Configure os filtros para visualizar</h5>

        <p className="text-muted mb-0">
          Selecione os filtros desejados e clique em "Visualizar" para
          visualizar o relatório da equipe.
        </p>
      </CardBody>
    </Card>
  );
};
